export default __webpack_public_path__ + "static/media/logo_security.9ab18f83.png";